import { render, staticRenderFns } from "./copy-button.vue?vue&type=template&id=03d95e0e&scoped=true"
import script from "./copy-button.vue?vue&type=script&lang=js"
export * from "./copy-button.vue?vue&type=script&lang=js"
import style0 from "./copy-button.vue?vue&type=style&index=0&id=03d95e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d95e0e",
  null
  
)

export default component.exports